import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './actions';
import { SelectedAttachmentDocument } from './models';

@Injectable({
	providedIn: 'root',
})
export class InstrumentsDispatch {
	@Dispatch()
	searchInstruments = (pin: string, instrumentIds: string[]) =>
		new actions.SearchDocuments({ pin, instrumentIds });

	@Dispatch()
	purchaseInstrumentDocuments = (pin: string, instruments: string[]) =>
		new actions.PurchaseInstrumentDocuments({ pin, instruments });

	@Dispatch()
	purchaseAttachmentDocuments = (attachments: SelectedAttachmentDocument[]) =>
		new actions.PurchaseAttachmentDocuments(attachments);
}
